import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { toPersianNum } from "../../assets/utils";
import "../../app/App.css";
import {
  ModalContainer,
  ModalText,
  ModalInput,
  ConfirmBtn,
  CancelBtn,
  BtnContainer,
  InputNum,
  InputError,
} from "./modalWalletCheckOut.styles";
const ModalWalletCheckOut = ({ visible, setVisible, bankInfo, socket }) => {
  // useEffect(() => {
  //   // setAccountInfo({ ...accountInfo, sheba: bankInfo[0].to_bank.sheba });
  // }),
  //   [bankInfo];

  const [accountInfo, setAccountInfo] = useState({
    interval: 0,
    sheba: "",
    type: 1,
  });
  const [errorText, setErrorText] = useState("");
  // useEffect(() => {
  //   console.log(accountInfo);
  // }),[accountInfo];
  useEffect(() => {
    if (bankInfo)
      setAccountInfo({ ...accountInfo, sheba: bankInfo?.[0]?.to_bank?.sheba });
  }, [bankInfo]);
  const handleCancel = () => {
    setVisible(false);
    setAccountInfo("");
    setErrorText("");
  };
  const AddSheba = () => {
    socket.emit("set_bank_info", accountInfo);
  };
  const InputValidation = (e) => {
    if (accountInfo.length == 0) {
      setErrorText("شماره شبا خود را وارد کنید");
    } else if (accountInfo.length > 0 && accountInfo.length != 24) {
      setErrorText("شماره شبا وارد شده اشتباه است");
    } else {
      AddSheba();
      setErrorText("");
      handleCancel();
    }
  };
  return (
    <div>
      <Modal
        footer={null}
        closable={false}
        visible={visible}
        onCancel={handleCancel}
      >
        <ModalText style={{ marginBottom: "10px" }}>
          برای تسویه حساب کافی است یک درخواست ثبت کنید.
        </ModalText>
        <ModalText>
          شماره شبا (الزاماً به نام خود فرد) نیازی به وارد کردن عبارت IR نیست.
          <span style={{ color: "#ffbf1d" }}>
            برای تسویه حساب آنی شماره شبای بانک ملی وارد نمائید.
          </span>
        </ModalText>
        <ModalInput>
          <InputNum
            type="text"
            value={toPersianNum(accountInfo.sheba)}
            onChange={(e) =>
              setAccountInfo({ ...accountInfo, sheba: e.target.value })
            }
          />
          IR
        </ModalInput>
        <InputError>{errorText}</InputError>
        <BtnContainer>
          <CancelBtn onClick={handleCancel}>لغو</CancelBtn>
          <ConfirmBtn onClick={InputValidation}>ثبت</ConfirmBtn>
        </BtnContainer>
      </Modal>
    </div>
  );
};

export default ModalWalletCheckOut;
